export enum QcsErrorCode {
  InvalidTraining = 'E003',
  EnteringBeforeEarliestEntryTime = 'E010',
  SupplierNotFound = '071'
}
